/* HeatLoop Cosy theme: storefront scripts (no dependencies) */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var strings = theme.strings || {};

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '£{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (cents / 100).toFixed(2);
    function delimit(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? dollars + decimal + parts[1] : dollars;
    }
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imageUrl(src, width) {
    if (!src) return '';
    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (e) { return src; }
  }

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (event) {
    var minus = event.target.closest('[data-qty-minus]');
    var plus = event.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty]');
    if (!wrap || wrap.hasAttribute('data-line-key')) return;
    var input = wrap.querySelector('input');
    var min = parseInt(input.min || '1', 10);
    var value = parseInt(input.value || '1', 10) + (plus ? 1 : -1);
    input.value = Math.max(min, value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Mobile menu ---------- */
  var menuDrawer = document.querySelector('[data-menu-drawer]');
  if (menuDrawer) {
    menuDrawer.addEventListener('toggle', function () {
      var header = document.querySelector('[data-header]');
      if (header) document.documentElement.style.setProperty('--header-bottom', Math.round(header.getBoundingClientRect().bottom) + 'px');
      document.body.classList.toggle('drawer-open', menuDrawer.open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuDrawer.open) { menuDrawer.open = false; menuDrawer.querySelector('summary').focus(); }
    });
  }

  /* ---------- Product: variants + gallery ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-to-cart-text]');
    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var priceBadge = root.querySelector('[data-price-badge]');
    var priceWrap = root.querySelector('[data-price]');
    var gallery = root.querySelector('[data-gallery]');
    var updateUrl = root.getAttribute('data-update-url') === 'true';

    // Gallery
    var slides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.gallery__slide')) : [];
    var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]')) : [];

    function showMedia(mediaId) {
      if (!slides.length) return;
      var found = false;
      slides.forEach(function (slide) {
        var active = String(slide.getAttribute('data-media-id')) === String(mediaId);
        slide.classList.toggle('is-active', active);
        if (active) found = true;
      });
      if (!found) { slides[0].classList.add('is-active'); mediaId = slides[0].getAttribute('data-media-id'); }
      thumbs.forEach(function (thumb) {
        var active = String(thumb.getAttribute('data-thumb')) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        if (active && thumb.parentElement) {
          var parent = thumb.parentElement;
          parent.scrollTo({ left: thumb.offsetLeft - parent.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
        }
      });
    }

    function step(dir) {
      var index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
      var next = (index + dir + slides.length) % slides.length;
      showMedia(slides[next].getAttribute('data-media-id'));
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showMedia(thumb.getAttribute('data-thumb')); });
    });
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    // Swipe on the main image (mobile)
    var main = root.querySelector('.gallery__main');
    if (main && slides.length > 1) {
      var startX = null;
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
        startX = null;
      });
    }

    // Variants
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('.option__input'));

    function selectedOptions() {
      var values = [];
      optionInputs.forEach(function (input) {
        if (input.checked) values[parseInt(input.getAttribute('data-option-index'), 10)] = input.value;
      });
      return values;
    }

    function findVariant(values) {
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) { return opt === values[i]; });
      });
    }

    function updateAvailability(values) {
      // Mark option values that have no available variant with the other current selections
      optionInputs.forEach(function (input) {
        var index = parseInt(input.getAttribute('data-option-index'), 10);
        var test = values.slice();
        test[index] = input.value;
        var match = findVariant(test);
        input.classList.toggle('is-unavailable', !match || !match.available);
      });
    }

    function onVariantChange() {
      var values = selectedOptions();
      values.forEach(function (value, i) {
        var label = root.querySelector('[data-option-selected="' + i + '"]');
        if (label) label.textContent = value;
      });
      var variant = findVariant(values);
      updateAvailability(values);

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = strings.unavailable || 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      if (addButton) addButton.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');

      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceWrap) priceWrap.classList.toggle('price--on-sale', !!onSale);
      if (priceCompare) {
        priceCompare.hidden = !onSale;
        priceCompare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      }
      if (priceBadge) {
        priceBadge.hidden = !onSale;
        if (onSale) {
          var pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
          priceBadge.textContent = (strings.save || 'Save') + ' ' + pct + '%';
        }
      }

      if (variant.featured_media) showMedia(variant.featured_media.id);

      if (updateUrl && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(new CustomEvent('theme:variant-change', { detail: { variant: variant, root: root } }));
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', onVariantChange); });
    if (optionInputs.length) updateAvailability(selectedOptions());

    // Ajax add to cart
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        var errorEl = root.querySelector('[data-form-error]');
        if (errorEl) errorEl.hidden = true;
        var buttons = document.querySelectorAll('[data-add-to-cart], [data-sticky-button]');
        buttons.forEach(function (b) { b.classList.add('is-loading'); });

        fetch(routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error(result.data.description || result.data.message || strings.cartError);
            return Cart.refresh(true);
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message || strings.cartError; errorEl.hidden = false; }
          })
          .finally(function () { buttons.forEach(function (b) { b.classList.remove('is-loading'); }); });
      });
    }
  }

  /* ---------- Sticky add to cart ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var mainBtn = document.querySelector('.section-main-product [data-add-to-cart]');
    if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
    var footer = document.querySelector('.footer');
    var mainVisible = true;
    var footerVisible = false;
    function update() {
      var show = !mainVisible && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      update();
    }).observe(mainBtn);
    if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);

    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var stickyBtn = bar.querySelector('[data-sticky-button]');
    document.addEventListener('theme:variant-change', function (e) {
      var v = e.detail.variant;
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (stickyBtn) stickyBtn.disabled = !v.available;
    });
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    drawer: document.querySelector('[data-cart-drawer]'),
    lastFocus: null,

    open: function () {
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      var panel = this.drawer.querySelector('.drawer__panel');
      if (panel) setTimeout(function () { panel.focus(); }, 50);
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (this.lastFocus) this.lastFocus.focus();
    },

    refresh: function (openAfter) {
      var self = this;
      return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          self.render(cart);
          if (openAfter) self.open();
          return cart;
        });
    },

    change: function (key, quantity) {
      var self = this;
      return fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { self.render(cart); });
    },

    render: function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      if (!this.drawer) return;
      var count = this.drawer.querySelector('[data-cart-drawer-count]');
      if (count) count.textContent = '(' + cart.item_count + ')';
      var body = this.drawer.querySelector('[data-cart-items]');
      var footer = this.drawer.querySelector('[data-cart-footer]');
      var subtotal = this.drawer.querySelector('[data-cart-subtotal]');

      if (cart.item_count === 0) {
        var tpl = document.querySelector('[data-cart-empty-template]');
        body.innerHTML = tpl ? tpl.innerHTML : '';
        if (footer) footer.hidden = true;
        return;
      }

      body.innerHTML = cart.items.map(function (item) {
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
        var compare = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
        var img = item.image ? '<img src="' + escapeHtml(imageUrl(item.image, 200)) + '" alt="" loading="lazy" width="84" height="84">' : '';
        return (
          '<div class="drawer__item">' +
            '<a href="' + escapeHtml(item.url) + '">' + img + '</a>' +
            '<div>' +
              '<a class="drawer__item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
              variant +
              '<div class="qty" data-qty data-line-key="' + escapeHtml(item.key) + '">' +
                '<button type="button" class="qty__btn" data-line-change="-1" aria-label="Decrease quantity"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
                '<input class="qty__input" type="number" value="' + item.quantity + '" min="0" aria-label="Quantity" data-line-input>' +
                '<button type="button" class="qty__btn" data-line-change="1" aria-label="Increase quantity"><svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
              '</div>' +
              '<button type="button" class="drawer__remove" data-line-remove="' + escapeHtml(item.key) + '">Remove</button>' +
            '</div>' +
            '<div class="drawer__item-price">' + compare + formatMoney(item.final_line_price) + '</div>' +
          '</div>'
        );
      }).join('');

      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (footer) footer.hidden = false;
    }
  };

  if (Cart.drawer) {
    document.addEventListener('click', function (event) {
      var openLink = event.target.closest('[data-cart-open]');
      if (openLink && !document.body.classList.contains('template-cart')) {
        event.preventDefault();
        Cart.refresh(true);
        return;
      }
      if (event.target.closest('[data-cart-close]')) { Cart.close(); return; }

      var changeBtn = event.target.closest('[data-line-change]');
      if (changeBtn) {
        var wrap = changeBtn.closest('[data-line-key]');
        var input = wrap.querySelector('[data-line-input]');
        var qty = Math.max(0, parseInt(input.value, 10) + parseInt(changeBtn.getAttribute('data-line-change'), 10));
        Cart.change(wrap.getAttribute('data-line-key'), qty);
        return;
      }
      var removeBtn = event.target.closest('[data-line-remove]');
      if (removeBtn) Cart.change(removeBtn.getAttribute('data-line-remove'), 0);
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-line-input]');
      if (!input) return;
      var wrap = input.closest('[data-line-key]');
      Cart.change(wrap.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && Cart.drawer.classList.contains('is-open')) Cart.close();
    });

    // Populate drawer on load so it's ready
    if (window.fetch) Cart.refresh(false).catch(function () {});
  }

  /* ---------- Init ---------- */
  function init() {
    document.querySelectorAll('[data-product]').forEach(initProduct);
    initStickyAtc();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-product]').forEach(initProduct);
  });

  window.HeatLoopCart = Cart;
})();
